import { Table, TableColumnsType } from "antd";
import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { getAttendanceByClass } from "../../../api/statistics.api";
import useAxios from "../../../hooks/useAxios";
import config from "../../../lib/config";
import exportTable from "../../../lib/exportTable";
import moment from "moment";
import { IAttendanceByClass, IGetAttendanceByClass } from "../../../models/statistics.model";
import { RootState } from "../../../store/rootReducer";
import DownloadButton from "../../DownloadButton";
import ErrorResponse from "../../ErrorResponse";
import Loader from "../../Loader";
import Pagination from "../../Pagination";

interface IProps {
  data: IAttendanceByClass[]|undefined;
  total: number|undefined;
  pageNo: number;
  setPageNo: (pageNo: number) => void;
  srtDate: string;
  endDate: string;
  campusCodes: string[];
}

const ByClass: FC<IProps> = ({
  data,
  total,
  pageNo,
  setPageNo,
  srtDate,
  endDate,
  campusCodes,
}) => {
  const { t } = useTranslation();
  const { auth } = useSelector((state: RootState) => state.auth);
  const { data: res, isLoading, error, execute } = useAxios<IGetAttendanceByClass>();

  useEffect(() => {
    if (res?.data && !isLoading) {
      const currentDate = moment(new Date());
      exportTable(columns, res.data, `${t('statistics.attendance.title1')}(${t('common.menu.class')})_(${currentDate.format('YYYYMMDD')})`, `${t('common.menu.class')}`, [12, 20, 10, 10, 10, 10, 10, 10, 12]);
    }
  }, [res, isLoading]);

  const onExportTable = () => {
    if (srtDate && endDate && campusCodes) {
      execute(getAttendanceByClass({
        srtDate,
        endDate,
        campusCode: auth.hqYn === 'Y'
          ? campusCodes
          : (campusCodes.length ? campusCodes : auth.campus),
        pageNo: 1,
        perPage: 999999999,
      }));
    }
  }

  const columns: TableColumnsType<IAttendanceByClass> = [
    {
      title: t('common.menu.campus'),
      dataIndex: 'campusKorName',
      key: 'campusKorName',
      align: 'center',
    },
    {
      title: t('common.menu.class'),
      dataIndex: 'className',
      key: 'className',
      align: 'center',
    },
    {
      title: t('class.class.column24'),
      dataIndex: 'classRooms',
      key: 'classRooms',
      align: 'center',
    },
    {
      title: t('class.class.column25'),
      dataIndex: 'instructors',
      key: 'instructors',
      align: 'center',
    },
    {
      title: t('student.student.column29'),
      dataIndex: 'teacherKorName',
      key: 'teacherKorName',
      align: 'center',
    },
    {
      title: t('statistics.attendance.column12'),
      dataIndex: 'studentCount',
      key: 'studentCount',
      align: 'center',
    },
    {
      title: t('statistics.attendance.column11'),
      dataIndex: 'unidentifiedCount',
      key: 'unidentifiedCount',
      align: 'center',
    },
    {
      title: t('statistics.attendance.column1'),
      dataIndex: 'attendCount',
      key: 'attendCount',
      align: 'center',
    },
    {
      title: t('statistics.attendance.column2'),
      dataIndex: 'absentCount',
      key: 'absentCount',
      align: 'center',
    },
    {
      title: t('statistics.attendance.column3'),
      dataIndex: 'recognitionAbsenceCount',
      key: 'recognitionAbsenceCount',
      align: 'center',
    },
    {
      title: t('statistics.attendance.column4'),
      dataIndex: 'lateCount',
      key: 'lateCount',
      align: 'center',
    },
    {
      title: t('statistics.attendance.column5'),
      dataIndex: 'earlyLeaveCount',
      key: 'earlyLeaveCount',
      align: 'center',
    },
    {
      title: t('statistics.attendance.column6'),
      dataIndex: 'attendRate',
      key: 'attendRate',
      align: 'center',
      render: value => Math.round(value),
    },
  ];

  return (
    <>
      {isLoading && <Loader />}
      <ErrorResponse error={error} />

      <div className="comm-table__area">
        <Table
          columns={columns}
          dataSource={data}
          pagination={{
            current: pageNo,
            pageSize: config.pageSize,
          }}
        />
      </div>
      <div className="comm-bx__between">
        <DownloadButton onClick={onExportTable} />
        <div className="common-paging center">
          <Pagination
            count={total || 0}
            page={pageNo}
            setPage={setPageNo}
          />
        </div>
      </div>    
    </>
  );
}

export default ByClass;
